
const EducationAndSkills = () => {
  return (
    <section
      id="education"
      data-nav-tooltip="Education"
      className="pp-section pp-scrollable section counter"
    >
      <div className="container">
        <div className="row align-items-center justify-content-center"></div>
        <div className="title">
          <h3>Educación &amp; Habilidades.</h3>
        </div>
        <div className="row">
          <div className="col-lg-4 m-15px-tb">
            <ul className="education-box">
              <li>
                <span>2024</span>
                <h6>Ingeniería en Informática</h6>
                <p>Instituto Profesional CIISA de la Universidad San Sebastián</p>
              </li>
              <li>
                <span>2023</span>
                <h6>Técnico en programación y Análisis de Sistemas</h6>
                <p>Instituto Profesional CIISA de la Universidad San Sebastián</p>
              </li>
              <li>
                <span>2018 a la fecha</span>
                <h6>Instructor y Presentador Nacional de BODYCOMBAT</h6>
                <p>Les Mills Chile</p>
              </li>
            </ul>
          </div>
          <div className="col-lg-7 ml-auto m-15px-tb justify-content-center align-items-center">
            <div className="skills-box justify-content-center align-items-center">
              <h3>Mis Habilidades</h3>
              <p>Desarrollador de software con experiencia en desarrollo web, combinado con una pasión por el fitness. Especializado en la creación de sitios web atractivos y funcionales. Confío en mi capacidad para aportar al éxito en ambos campos: tecnología y bienestar físico.</p>
              <div className="skill-lt">
                <h4>HTML, CSS, JavaScript, PHP, Python, entre otros.</h4>
                {/* <div className="skill-bar">
                  <div className="skill-bar-in" style={{ width: "80%" }}>
                    <span data-toggle="tooltip" title="Proficient" />
                  </div>
                </div> */}
              </div>
              {/* /skill */}
              {/* <div className="skill-lt">
                <h6>CSS</h6>
                <div className="skill-bar">
                  <div className="skill-bar-in" style={{ width: "65%" }}>
                    <span data-toggle="tooltip" title="Competent" />
                  </div>
                </div>
              </div> */}
              {/* /skill */}
              {/* <div className="skill-lt">
                <h6>JavaScript</h6>
                <div className="skill-bar">
                  <div className="skill-bar-in" style={{ width: "70%" }}>
                    <span data-toggle="tooltip" title="Competent" />
                  </div>
                </div>
              </div> */}
              {/* /skill
              <div className="skill-lt">
                <h6>PHP</h6>
                <div className="skill-bar">
                  <div className="skill-bar-in" style={{ width: "65%" }}>
                    <span data-toggle="tooltip" title="Competent" />
                  </div>
                </div>
              </div> */}
              {/* /skill */}
              {/* <div className="skill-lt">
                <h6>Python</h6>
                <div className="skill-bar">
                  <div className="skill-bar-in" style={{ width: "75%" }}>
                    <span data-toggle="tooltip" title="Competent" />
                  </div>
                </div>
              </div> */}
              {/* /skill */}
            </div>
          </div>
        </div>

      </div>
      <div className="separated" />
    </section>

  );
};
export default EducationAndSkills;
